import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";
import { Truck, Workflow, ShieldAlert, Scale, ArrowUpRight } from "lucide-react";

export default function Services() {
  const { t } = useLang();
  const services = [
    { icon: Truck, t: t("services.s1_t"), d: t("services.s1_d") },
    { icon: Workflow, t: t("services.s2_t"), d: t("services.s2_d") },
    { icon: ShieldAlert, t: t("services.s3_t"), d: t("services.s3_d") },
    { icon: Scale, t: t("services.s4_t"), d: t("services.s4_d") },
  ];

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-[#0D0D0F]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="gold-divider" />
              <span className="label-gold">{t("services.label")}</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-[1.05] tracking-tight">
              {t("services.title")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                data-testid={`service-card-${i}`}
                className="group relative p-10 lg:p-12 bg-[#161618] border border-white/10 rounded-sm hover:border-[#F2B705]/50 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="w-14 h-14 rounded-sm bg-[#F2B705]/10 flex items-center justify-center border border-[#F2B705]/20 group-hover:bg-[#F2B705]/20 transition-colors">
                    <Icon className="w-6 h-6 text-[#F2B705]" strokeWidth={1.5} />
                  </div>
                  <ArrowUpRight
                    className="w-5 h-5 text-neutral-600 group-hover:text-[#F2B705] group-hover:rotate-12 transition-all"
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="font-display text-xl lg:text-2xl font-semibold text-white mb-4">
                  {s.t}
                </h3>
                <p className="text-sm lg:text-base text-neutral-400 leading-relaxed">
                  {s.d}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
